"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchPaymentsArtifact = void 0;
const ContractArtifact_1 = require("../../ContractArtifact");
const _0_1_0_json_1 = require("./0.1.0.json");
exports.batchPaymentsArtifact = new ContractArtifact_1.ContractArtifact({
    '0.1.0': {
        abi: _0_1_0_json_1.abi,
        deployment: {
            private: {
                address: '0x1411CB266FCEd1587b0AA29E9d5a9Ef3Db64A9C5',
                creationBlockNumber: 0,
            },
            rinkeby: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 10857190,
            },
            goerli: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 7091488,
            },
            mainnet: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 14884721,
            },
            matic: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 29028253,
            },
            celo: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 13301318,
            },
            fuse: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 17329966,
            },
            xdai: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 22438505,
            },
            bsc: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 18772049,
            },
            fantom: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 39541135,
            },
            'arbitrum-one': {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 13425347,
            },
            avalanche: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 16157128,
            },
            optimism: {
                address: '0x0DD57FFe83a53bCbd657e234B16A3e74fEDb8fBA',
                creationBlockNumber: 35498688,
            },
            zksyncera: {
                address: '0x0C41700ee1B363DB2ebC1a985f65cAf6eC4b1023',
                creationBlockNumber: 19545614,
            },
            zksynceratestnet: {
                address: '0x276A92F78aA527b8e157B0E47cEB63b4239dfa0b',
                creationBlockNumber: 13814862,
            },
        },
    },
}, '0.1.0');
